import { RootEpic } from 'MyTypes';
import { forkJoin, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { isActionOf, isOfType } from 'typesafe-actions';

import {
    getAgeGroupsAsync,
    getCountryLocationsSdi,
    getDataCollectionsAsync,
    getDataProjectsAsync,
    getDatasetsAsync,
    getOrganizationsAsync,
    getRoundsAsync,
    requiredDataLoaded,
} from './data/actions';
import {
    getCausesAsync,
    getEtiologiesAsync,
    getImpairmentsAsync,
    getInjuryAsync,
    getLocationsAsync,
    getRisksAsync,
    getSequelasAsync,
} from './entity-hierarchies/actions';
import { SESSION_ACCOUNT_LOADED, SESSION_SIGNED_IN } from './session/types';

// triggers are modelling dependencies between store modules

export const triggerLoadEntityHierarchies: RootEpic = (action$, state$) =>
    action$.pipe(
        filter(isOfType([SESSION_ACCOUNT_LOADED, SESSION_SIGNED_IN])),
        switchMap((action) =>
            of(
                getDataCollectionsAsync.request(),
                getDataProjectsAsync.request(),
                getDatasetsAsync.request(),
                getRoundsAsync.request(),
                getLocationsAsync.request(),
                getCausesAsync.request(),
                getSequelasAsync.request(),
                getEtiologiesAsync.request(),
                getImpairmentsAsync.request(),
                getInjuryAsync.request(),
                getRisksAsync.request(),
                getOrganizationsAsync.request(),
                getAgeGroupsAsync.request(),
                getCountryLocationsSdi.request()
            )
        )
    );

const REQUIRED_DATA_LOADS = [getRoundsAsync, getOrganizationsAsync, getDataCollectionsAsync];

export const trackRequiredDataLoaded: RootEpic = (action$) =>
    action$.pipe(
        filter(isOfType([SESSION_ACCOUNT_LOADED, SESSION_SIGNED_IN])),
        switchMap(() =>
            forkJoin(
                REQUIRED_DATA_LOADS.map((asyncAction) =>
                    action$.pipe(
                        filter(isActionOf([asyncAction.success, asyncAction.failure])),
                        take(1)
                    )
                )
            ).pipe(map(() => requiredDataLoaded()))
        )
    );
